module.exports = __webpack_public_path__ + "img/image-8.099e20e8.webp";